import * as React from "react";
const TikTok = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 8a4 4 0 0 1-4-4h-2v10a3 3 0 1 1-1.5-2.599V9.23A5 5 0 1 0 15 14V8.473A5.978 5.978 0 0 0 19 10V8Z" }));
TikTok.displayName = "TikTok";
var TikTok_default = TikTok;
export {
  TikTok_default as default
};
